import React from "react";
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import BALogo from "../BALogo";

import './footer.css';

const Footer = ({ className: styledClassName, ...rest}) => {
    return <div className={`${styledClassName}`} {...rest}>
        <div>
            <NavLink tag={Link} className="" to="/">
                <div className="footer-logo">
                    <div className="footer-ba-logo__div">
                        <BALogo customClassName={"footer-ba-logo"} primaryColor={"#DDD"}/>
                    </div>
                    <div className="footer-ba-text footer-text ">
                        Bonos Y Apuestas
                    </div>
                </div>     
            </NavLink>
        </div>
        <div className="footer-nav">
            <NavLink tag={Link} className="footer-nav__linkcomp" to="/Comparador">Comparador</NavLink>
            <NavLink tag={Link} to="/opiniones">Opiniones</NavLink>
            <NavLink tag={Link} className="footer-nav__linkbonos" to="/bonos">Bonos</NavLink>
        </div>
        <div className="footer-copyright footer-text ">
            &#169; Copyright Bonos y Apuestas {(new Date().getFullYear())}
        </div>
        <div className="footer-copyright footer-text ">
            <img className="footer-img" src="assets/images/responsabilidad.png" />
            <img className="footer-img" src="assets/images/juegoseguro.png" />
            <img className="footer-img footer-img__jugarbien" src="assets/images/juegabien.png" />
            <img className="footer-img footer-img__18plus" src="assets/images/18plus.png" />
            <img className="footer-img footer-img__autopohibicion" src="assets/images/autoprohibicion.png" />
        </div>
    </div>
};

export default Footer;